<template>
  <v-data-table
    style="cursor: pointer"
    :items="tanks"
    :headers="tanksHeaders"
    :items-per-page="-1"
    group-by="vessel.name"
    @click:row="goToTankDetails"
    :mobile-breakpoint="dataTableMobileBreakpoint"
  >
    <template v-slot:top>
      <div class="d-flex text-start pa-4">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-car-coolant-level</v-icon>
          Unrecorded Tanks
        </span>
      </div>
    </template>
    <template v-slot:group.header="props">
      <td
        class="text-start pa-2 font-weight-medium"
        :colspan="props.headers.length"
      >
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-icon left>mdi-ferry</v-icon>
              {{ props.group }}
            </span>
          </template>
          Vessel: {{ props.group }}
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.tankBulkType="{ item }">
      <span>{{ item.tankBulkType }}</span>
    </template>
  </v-data-table>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
import TankStatusMixin from '../../mixins/TankStatusMixin';

export default {
  name: 'DailyTankReportTanksTable',
  mixins: [TankStatusMixin, ResponsiveSizeHelperMixin],
  props: {
    tanks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tanksHeaders: [
        { text: 'Tank', value: 'tankName' },
        { text: 'Type', value: 'tankBulkType' },
        { text: 'Bulk', value: 'bulkName' },
      ],
    };
  },
};
</script>
